/* eslint-disable @typescript-eslint/indent */
import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BranchDataParsed } from 'Types/GlobalTypes';
import { selectData, selectLoading } from 'Selector/BranchSelector';
import { navigateToAuthServer } from 'Utils/UtilityFunctions';

const DeepLinkView = function DeepLinkView() {
  const navigate = useNavigate();

  const branchLoading = useSelector(selectLoading);
  const branchData = useSelector(selectData);

  const switchFunction = (obj: BranchDataParsed) => {
    if (!isEmpty(obj)) {
      const id = obj.id || obj.$canonical_identifier;
      switch (obj.entity) {
        case 'article':
          navigate(`/feed/spotlight?articleId=${id}`);
          break;
        case 'person':
          navigate(`/person/personalityinsights?personId=${id}&personType=EXECUTIVE`);
          break;
        case 'company':
          navigate(`/company/news?companyId=${id}&scroll=true`);
          break;
        case 'person_share':
          navigate(`/person/personalityinsights?personId=${id}&personType=EXECUTIVE`);
          break;
        case 'company_share':
          navigate(`/company/overview?companyId=${id}`);
          break;
        case 'login':
          navigateToAuthServer();
          break;
        case 'reset_password':
          navigate(`/password?option=reset_password&key=${obj.key}`);
          break;
        case 'widget':
          if (obj.type === 'alert_feeds' || obj.type === 'news_layout_2' || obj.type_widget === 'alert_feeds') {
            navigate('/feed/news?scroll=true');
          }
          break;
        default:
          navigate('/feed/');
      }
    } else {
      navigate('/feed/');
    }
  };

  useEffect(() => {
    if (branchData && branchLoading === false) {
      const { data_parsed: dataParsed } = branchData;
      switchFunction(dataParsed);
    }
  }, [branchLoading]);

  return <div />;
};

export default DeepLinkView;
